module.exports = __webpack_public_path__ + "static/media/Socks_thumb.7ba3cc5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/weird-wonderful/Socks_thumb.jpg
// module id = 368
// module chunks = 0